export default "__VITE_ASSET__DKWBuZWo__"